import "./Main.scss";
// REACT; ROUTER
import { useEffect } from "react";
import { Route } from "react-router-dom";
import { Routes, useLocation } from "react-router";

// COMPONENTS & FUNCTIONS
import CatalogueUnit from "../../components/units/CatalogueUnit";

// Pages
import HomePage from "../../pages/HomePage";
import NewsPage from "../../pages/NewsPage";
import ArchivePage from "../../pages/ArchivePage";
import CalculatorPage from "../../pages/CalculatorPage";
import CataloguePage from "../../pages/CataloguePage";
import FlowPage from "../../pages/FlowPage";

// Data
import { pipeData } from "../../engineering/catalogues/pipeData";
import { waterData } from "../../engineering/catalogues/waterData";
import { thermalData } from "../../engineering/catalogues/thermalData";
import { gdntData } from "../../engineering/catalogues/GDnTData";
import { unitsData } from "../../engineering/catalogues/unitsData";
import { frictionData } from "../../engineering/catalogues/frictionData";
import { screwData } from "../../engineering/catalogues/screwData";

// INTERFACES
import { DataType } from "../../interface/dataTypeInterface";
import { MainProps } from "../../interface/propTypesInterface";

/*
MAIN COMPONENT INFORMATION
  In Main page, the router decides what PAGES component get loaded onto it.
  Multiple features
  1) When pathname changes, force scroll to go to top of page
  2) When in CataloguePage and choosing catalogue, load the catalogue based on URL into CatalogueUnit
  3) When reloading page, get all data for CataloguePage from LocalStorage and add them to state
*/

export default function Main(props: MainProps) {
  // ::::: USEHOOKS :::::::
  const pathname = useLocation().pathname;
  const destination = pathname.split("/")[pathname.split("/").length - 1];

  // Scroll to top whenever user changes path
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Load corrent data into catalogue
  let data: DataType[];
  if (destination.includes("pipeData")) {
    data = pipeData;
  } else if (destination.includes("waterData")) {
    data = waterData;
  } else if (destination.includes("thermalData")) {
    data = thermalData;
  } else if (destination.includes("gdntData")) {
    data = gdntData;
  } else if (destination.includes("unitsData")) {
    data = unitsData;
  } else if (destination.includes("frictionData")) {
    data = frictionData;
  } else if (destination.includes("screwData")) {
    data = screwData;
  } else {
    data = [];
  }
  // // when window reloads
  // window.onload = handleReload;

  return (
    <main className="main">
      <Routes>
        <Route path="" element={<HomePage />} />
        <Route path="news" element={<NewsPage />} />
        <Route path="news/archive" element={<ArchivePage />} />
        <Route
          path="calculator"
          element={<CalculatorPage showNotification={props.showNotification} />}
        />
        <Route path="catalogue" element={<CataloguePage />} />

        <Route
          path={`catalogue/${destination}`}
          element={<CatalogueUnit data={data} />}
        />
        <Route path="flow" element={<FlowPage />} />
      </Routes>
    </main>
  );
}
